/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { BounceLoader } from "react-spinners";
import { format, parseISO } from "date-fns";
import { PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import Pagination from "../../../Helper/Pagination";
import { Link } from "react-router-dom";
import { toastEmmit } from "../../../Helper/Toastr";

export default function PaymentHistory() {
  const [Loading, setLoading] = useState(false);
  const [PaymentList, setPaymentList] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [userLimit, setUserLimit] = useState(10);
  const [status, setstatus] = useState("");

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  useEffect(() => {
    getList();
  }, [currentPage, status]);

  const getList = () => {
    setLoading(true);
    const dataObj = {
      status: status,
      size: "10",
      page: currentPage,
    };
    PostService(API_URL.GET_PAYMENT_LIST, dataObj).then((res) => {
      console.log(res);
      if (res?.data?.status) {
        setPaymentList(res?.data?.data?.item);
        setTotalPages(res.data?.data?.totalPages);
        setTotal(res?.data?.data?.totalItems);
      } 
      // else {
      //   toastEmmit("error", res?.data?.message);
      // }
      setLoading(false);
    });
  };

  return (
    <>
      <div
        className="tab-pane fade active show"
        id="nav-Paper"
        role="tabpanel"
        aria-labelledby="nav-Paper-tab"
        tabIndex={0}
      >
        <div className="row">
          <div className="productdetails-tabs mb-50">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-12">
                <div className="col-xl-12 col-lg-12 col-md-6">
                  <div className="heading">
                    <p>Payment History </p>
                  </div>
                </div>
              </div>
              <div className="product-additional-tab">
                <div className="pro-details-nav mb-30">
                  <ul
                    className="nav nav-tabs pro-details-nav-btn"
                    id="myTabs"
                    role="tablist"
                  >
                    <li className="nav-item mr-20" role="presentation">
                      <button
                        className="nav-links active"
                        id="information-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#additional-information"
                        type="button"
                        role="tab"
                        aria-controls="additional-information"
                        aria-selected="true"
                        onClick={() => setstatus("")}
                      >
                        <span>All</span>
                      </button>
                    </li>
                    <li className="nav-item mr-20" role="presentation">
                      <button
                        className="nav-links"
                        id="reviews-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#additional-information"
                        type="button"
                        role="tab"
                        aria-controls="reviews"
                        aria-selected="false"
                        tabIndex={-1}
                        onClick={() => setstatus("COMPLETED")}
                      >
                        <span>Paid</span>
                      </button>
                    </li>
                    <li className="nav-item mr-20" role="presentation">
                      <button
                        className="nav-links"
                        id="reviews-tab-1"
                        data-bs-toggle="tab"
                        data-bs-target="#additional-information"
                        type="button"
                        role="tab"
                        aria-controls="reviews"
                        aria-selected="false"
                        tabIndex={-1}
                        onClick={() => setstatus("pending")}
                      >
                        <span>Pending</span>
                      </button>
                    </li>
                    <li className="nav-item mr-20" role="presentation">
                      <button
                        className="nav-links"
                        id="reviews-tab-2"
                        data-bs-toggle="tab"
                        data-bs-target="#additional-information"
                        type="button"
                        role="tab"
                        aria-controls="reviews"
                        aria-selected="false"
                        tabIndex={-1}
                        onClick={() => setstatus("failed")}
                      >
                        <span>Failed</span>
                      </button>
                    </li>
                  </ul>
                </div>
                {/* tab-content */}
                {PaymentList.length > 0 && (
                  <div className="tp-content-tab" id="myTabContent-2">
                    <div
                      className="tab-pane fade active show"
                      id="additional-information"
                      role="tabpanel"
                      aria-labelledby="information-tab"
                    >
                      <div className="Section3 ">
                        <div className="container user-profile ">
                          <div className="DataTable1 table-sm table-responsive">
                            {/* table-striped */}
                            <table className="table  first last data table payment table-striped">
                              <thead>
                                <tr>
                                  <th scope="col">Transaction ID</th>
                                  <th scope="col" className="text-center">
                                    Order ID
                                  </th>
                                  <th scope="col" className="text-center">
                                    Date
                                  </th>
                                  <th scope="col">Amount</th>
                                  <th scope="col">Payment Method</th>
                                  <th scope="col" className="text-center">
                                    Status
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="last">
                                {PaymentList &&
                                  PaymentList.map((data) => (
                                    <tr>
                                      <td>{data?.transaction_id}</td>
                                      <td className="text-center">
                                        {data?.orderId}
                                      </td>
                                      <td className="text-center">
                                        {data?.created_at
                                          ? format(
                                              parseISO(data?.created_at),
                                              "dd-MM-yyyy HH:mm"
                                            )
                                          : "N/A"}
                                      </td>
                                      <td className="text-center text-primary fw-semibold">
                                        ${parseFloat(data?.amount).toLocaleString()}
                                      </td>
                                      <td className="text-center text-uppercase">
                                        {data?.payment_method}
                                      </td>
                                      <td>
                                        <div
                                          className={`btn btn-sm rounded-0 px-2 ${
                                            data?.status === "COMPLETED"
                                              ? "btn-success"
                                              : data?.status === "PENDING"
                                              ? "btn-warning"
                                              : data?.status === "CANCELLED"
                                              ? "btn-danger"
                                              : data?.status === "FAILED"
                                              ? "btn-danger"
                                              : data?.status === "REFUNDED"
                                              ? "btn-info"
                                              : data?.status === "REVERSED"
                                              ? "btn-secondary"
                                              : ""
                                          }`}
                                        >
                                          {data?.status}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div> 
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                   {PaymentList.length<1 &&
                                  <div style={{display:'grid', justifyContent:'center', alignItems:'center'}}>
                                    <img src="assets/img/breadcrumb/nodata.png" alt=""  style={{height:'320px',width:'320px'}}/>
                                  </div>
                                  }
              </div>
            </div>
          </div>
        </div>

        {Loading ? (
          <div className="LoaderSpinner">
            <BounceLoader
              color={"#003bff"}
              loading={Loading}
              speedMultiplier={2}
              size={50}
            />
            <div>Loading... Please wait.</div>
          </div>
        ) : (
          ""
        )}

        {PaymentList.length > 0 && (
          <Pagination
            counting={currentPage * userLimit}
            totaldata={total}
            pagecount={totalPages}
            onChangePage={handlePageClick}
            activePage={currentPage}
          />
        )}
      </div>
    </>
  );
}
